export enum REQUEST_STATUS_LIST {
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR',
    LOADING = 'LOADING',
    IDLE = 'IDLE'
}
